import React from 'react';
import TextBox from '../../components/TextBox';
import ContentOuterBound from '../../components/common/atoms/ContentOuterBound';
import ContentSpacer from '../../components/common/atoms/ContentSpacer';
import { BlockInstanceProps } from '../Block';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';
import { BackgroundColorEnum } from '../../constants/cms-constants';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  { key: 'openInNewTab', definition: controlOptionDefinitions.boolean },
])
class BodyTextBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const openInNewTab = controlOptions?.openInNewTab;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    return (
      <ContentOuterBound>
        <ContentSpacer>
          <TextBox
            input={block?.bodyText}
            openInNewTab={openInNewTab}
            backgroundColor={backgroundColor}
          />
        </ContentSpacer>
      </ContentOuterBound>
    );
  }
}

export default BodyTextBlock;
